import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  CREATE_ASSET_READING_SUCCESS,
  FETCH_ASSET_LAST_READING_SUCCESS,
  FETCH_ASSET_LAST_READING_WITH_TIME_SUCCESS,
  FETCH_ASSET_READING_SUCCESS,
  FETCH_ASSET_VERIFICATION_READING_RECORD_SUCCESS,
  GET_ASSET_READING_SUCCESS,
  SAVE_ASSET_READING_QUERY,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchFilter, fetchStart, fetchSuccess, } from "./Common";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from '../../util/methods';


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_ASSET_READING_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_ASSET_READING_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_ASSET_READING_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  // console.log(`Here > - ${data}`);
  return {
    type: FETCH_ASSET_READING_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { assetReading } = store.getState();
      const { query } = assetReading;
      // console.log('query', query)
      const response = await axios.get(`/asset-meter-reading?${generateQueryString(query)}`);
      // console.log('response', response)
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      console.log("Error****:", error);
      // message.error(error.response.data.message);
      // message.error("Record not found");
      dispatch(fetchError(error.response.data.message));

    }
  }
};

export const createResource = (payload, redirect = true, module) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const documents = payload.documents;
      let body = payload;
      let config;
      if (Array.isArray(documents) && documents.length) {
        const formData = new FormData();
        documents.forEach((file) => {
          formData.append('files', file);
        });
        Object.keys(payload).forEach((key) => {
          if (key === 'documents' || payload[key] === undefined || payload[key] === null) {
            return;
          }
          const value = payload[key];
          if (value && typeof value.toISOString === 'function') {
            formData.append(key, value.toISOString());
          } else if (typeof value === 'object') {
            formData.append(key, JSON.stringify(value));
          } else {
            formData.append(key, value);
          }
        });
        body = formData;
        config = { headers: { 'Content-Type': 'multipart/form-data' } };
      } else if (Object.prototype.hasOwnProperty.call(payload, 'documents')) {
        body = { ...payload };
        delete body.documents;
      }
      const response = await axios.post(`/asset-meter-reading`, body, config);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
        dispatch(fetchSuccess());
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));

        if (!redirect) {
          dispatch(fetchFilter(module));
        } else {
          history.push('/asset-meter-reading');
          dispatch(getResource());
        }
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.put(`/asset-meter-reading/${id}`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      history.push('/asset-meter-reading');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/asset-meter-reading/${id}`);
      // console.log(`Here - ${response.data}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      await axios.delete(`/asset-meter-reading/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getLastReading = (meter) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/asset-meter-reading/last-reading/${meter}`);
      // console.log(`Here - ${response.data}`);
      dispatch(fetchSuccess());
      dispatch(fetchLastReadingSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchLastReadingSuccess = ({ data }) => {
  return {
    type: FETCH_ASSET_LAST_READING_SUCCESS,
    data
  };
};

export const getLastReadingTimeBased = (meter, timestamp) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      // let time = timestamp
      // if (String(timestamp).length === 13)
      //   time = timestamp / 1000;
      // console.log('time', timestamp, meter)
      const response = await axios.get(`/asset-meter-reading/last-reading/${meter}/${timestamp}`);
      // console.log(`Here - ${response.data}`);
      dispatch(fetchSuccess());
      dispatch(fetchLastReadingWithTimeSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const fetchLastReadingWithTimeSuccess = ({ data }) => {
  return {
    type: FETCH_ASSET_LAST_READING_WITH_TIME_SUCCESS,
    data
  };
};

export const getVerificationReadingRecord = (asset, meter, timestamp, fid = '') => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      // let time = timestamp
      // if (String(timestamp).length === 13)
      //   time = timestamp / 1000;
      // console.log('time', timestamp, meter)
      const response = await axios.get(`/asset-meter-reading/verify-reading-in-time/${asset}/${meter}/${timestamp}?fid=${fid || ''}`);
      // console.log(`Here - ${JSON.stringify(response.data, null, 2)}`);
      dispatch(fetchSuccess());
      dispatch(getVerificationReadingRecordSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getVerificationReadingRecordSuccess = ({ data }) => {
  return {
    type: FETCH_ASSET_VERIFICATION_READING_RECORD_SUCCESS,
    data
  };
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const { subAssembly } = store.getState();
      const { query } = subAssembly;
      const response = await axios.get(`/asset-meter-reading/download?columns=${columns}&${generateQueryString(query)}`);
      // console.log('response', response)
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns);
      // console.log('str', str)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};